import { render, staticRenderFns } from "./ModalMantenedor.vue?vue&type=template&id=4ccdaea5&"
import script from "./ModalMantenedor.vue?vue&type=script&lang=ts&"
export * from "./ModalMantenedor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4ccdaea5', component.options)
    } else {
      api.reload('4ccdaea5', component.options)
    }
    module.hot.accept("./ModalMantenedor.vue?vue&type=template&id=4ccdaea5&", function () {
      api.rerender('4ccdaea5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/ModalMantenedor.vue"
export default component.exports